module.exports = __webpack_public_path__ + "img/21-2.6f138935.png";